import { Component, OnInit,ViewChild, NgZone,ElementRef } from '@angular/core';
import { CookieService } from '../_services/cookie.service';
import { ReportService } from '../inservice/report.service';
import { Title, DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import { Router} from '@angular/router';
import {CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Table } from 'primeng/table';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { throwError } from 'rxjs';
// import { format } from 'path';
declare var $: any;

@Component({
  selector: 'app-reportresources',
  templateUrl: './reportresources.component.html',
  styleUrls: ['./reportresources.component.css']
})
export class ReportresourcesComponent implements OnInit {

	constructor(private router: Router, private ngZone: NgZone, private fb: FormBuilder, private titleService :Title,  public sanitizer: DomSanitizer, private cookieService: CookieService, private reportService:ReportService) { 
		this.getUserDetail();	
		this.reportService.stream$.subscribe(this.receiveMessage.bind(this))


	}
	receiveMessage(msg : string) {
		console.log(msg); // your message from component A
	}
		userId;
	public showLogo=0;
	public logOutFlag=0;
	r;
	userInfo;
	userName;
	libraryData=[];
	cols;
	slotCols;
	templateCols;
	coverpageCols;
	headerCols;
	footerCols;
	templateRow;
	cols2;
	pcaCols=[];
	pcaCols2=[];
	watermarkCols=[];
	form;
	form1;
	formCheck=false;
	addLibShow=false;
	defaultWM=-1;
	acceptType=[];
	@ViewChild('excelFile') excelFile: ElementRef;
	@ViewChild('file3') file3: ElementRef;
	@ViewChild('hfFile') hfFile: ElementRef;
	@ViewChild('ttt') private tt: Table;
	@ViewChild('py') private py: Table;
	ngOnInit(): void {
		//console.log(this.alphaOrder(["CONTENT", "TITLE", "INSTRUCTIONS", "IDENTIFIERS", "CONTENT_HTML", "INSTRUCTIONS_HTML","LIBRARY_ID"]))
		this.titleService.setTitle("SCRIVA-Libraries");
		this.acceptType=this.reportService.acceptFileType.split(',');
		this.getCompanyGroupIndicator();
		this.cols=[
			{ field: 'ITEM_TITLE',searchField:'ITEM_TITLE', header: 'Title', width: '20%'},
			{ field: 'SHORT_CONTENT',searchField:'CONTENT', header: 'Content', width: '50%'},
			//{ field: 'INSTRUCTIONS',searchField:'INSTRUCTIONS', header: 'Instructions', width: '40%'},
			{ field: 'LABELS',searchField:'LABELS', header: 'Identifier', width: '10%'},
			{ field: 'STATUS',searchField:'STATUS', header: 'Status', width: '10%'},
			{field: 'EDIT',searchField:'EDIT', header:'Actions', width:"10%"}
		]

		this.form = this.fb.group({
		confirmTitle:['',[Validators.required]]
		})
		this.form1 = this.fb.group({
			confirmCostTitle:['',[Validators.required]]
		})
		
		this.watermarkCols=[
			{ field: 'WM_TITLE', header: 'Title', width: '10%'},
			{ field: 'text', header: 'Text', width: '10%'},
			{ field: 'position', header: 'Position', width: '10%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '10%'},
			{field: 'CREATED_BY', header:'Created By', width:"7%"},
			{field: 'EDIT', header:'Edit', width:"4%"}
		]
		this.pcaCols=[
			{ field: 'ITEM_TITLE',searchField:'ITEM_TITLE', header: 'Title', width: '10%'},
			{ field: 'EUL',searchField:'EUL', header: 'EUL', width: '10%'},
			{ field: 'COST',searchField:'COST', header: 'Cost', width: '10%'},
			{ field: 'UNIT',searchField:'UNIT', header: 'Unit', width: '10%'},
			{ field: 'IDENTIFIERS',searchField:'IDENTIFIERS', header: 'Identifier', width: '10%'},
			{ field: 'STATUS',searchField:'STATUS', header: 'Status', width: '3%'},
			{ field: 'EDIT', header:'Actions', width:"4%"}
		]

		this.pcaCols2=[
			{ field: 'COST_LIBRARY_ID', header: 'ID', width: '10%'},
			{ field: 'ITEM_TITLE', header: 'Title', width: '10%'},
			{ field: 'EUL', header: 'EUL', width: '10%'},
			{ field: 'COST', header: 'Cost', width: '10%'},
			{ field: 'UNIT', header: 'Unit', width: '10%'},
			{ field: 'IDENTIFIERS', header: 'Identifier', width: '10%'},
		]
		this.coverpageCols=[
			{ field: 'COVERPAGE_TITLE', header: 'Coverpage Title', width: '20%'},
			//{ field: 'COVERPAGE_URL', header: 'Template Name', width: '20%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '20%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '20%'},
			//{ field: 'COVERPAGE_TITLE', header: 'Template Name', width: '20%'},
		]
		this.templateCols=[

			{ field: 'TEMPLATE_TITLE', header: 'Template Name', width: '20%'},
			{ field: 'CATEGORY_NAME', header: 'Template Type', width: '7%'},
			{ field: 'SUBCATEGORY_NAME', header: 'Template Identifier', width: '10%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '10%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '10%'},
			{ field: 'DATE_UPDATED', header: 'Modified Date', width: '10%'},
			{ field: 'STATUS', header: 'Status', width: '5%'},
			{field: 'EDIT', header:'Edit', width:"5%"}
		]
		this.headerCols=[
			{ field: 'HF_TITLE', header: 'Header Title', width: '20%'},
			//{ field: 'COVERPAGE_URL', header: 'Template Name', width: '20%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '20%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '20%'},

		]
		this.footerCols=[
			{ field: 'HF_TITLE', header: 'Footer Title', width: '20%'},
		//{ field: 'COVERPAGE_URL', header: 'Template Name', width: '20%'},
			{ field: 'DATE_CREATED', header: 'Date Created', width: '20%'},
			{ field: 'CREATED_BY', header: 'Created By', width: '20%'},
		]


	//   Template Name
	// Template Category
	// Template Identifier
	// Created by
	// "TEMPLATE_TITLE": "ERIS Demo",
	// "CATEGORY_NAME": "Environmental",
	// "SUBCATEGORY_NAME": "Phase I - ASTM",
	// "DATE_UPDATED": "23-JUN-21 01:05:07 PM",
	// "UPDATED_BY": "Wenck Fort Collins"
		this.cols2=[
			{ field: 'LIBRARY_ID', header: 'ID', width: '10%'},
			{ field: 'ITEM_TITLE', header: 'Title', width: '10%'},
			{ field: 'CONTENT', header: 'Content', width: '40%'},
			{ field: 'CONTENT_HTML', header: 'Content HTML', width: '10%'},
			{ field: 'INSTRUCTIONS', header: 'Instructions', width: '40%'},
			{ field: 'INSTRUCTIONS_HTML', header: 'Instructions HTML', width: '40%'},
			{ field: 'LABELS', header: 'Identifier', width: '10%'},
	// {field: 'EDIT', header:'Edit', width:"4%"}
		]
		this.slotCols=[
			{ field: 'KEY', header: 'Title', width: '20%'},
			{ field: 'CATEGORY', header: 'Category', width: '20%'},
			{ field: 'TYPE', header: 'Type', width: '20%'},
			{ field: 'CONTENT', header: 'Content', width: '20%'},
			{ field: 'SYSTEM_CUSTOMIZE', header: 'System/ Customize', width: '5%'},
			{ field: 'STATUS', header: 'Status', width: '5%'},
			{field: 'EDIT', header:'Edit', width:"5%"}
		]
		$(document).ready(function () {
			$('#addSlotModal').draggable();			
			});
  	}
	onSavedLogo(e){
		//this.tick = +(new Date());
		this.showLogo = e;
    
	}
  	logOut(){
		this.logOutFlag++; console.log(this.logOutFlag);
	}

	
	changeLibraryStatus(library) {

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "LIBRARY_ID":library.LIBRARY_ID, "FUNCTION_ID": 34};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				// console.log('lib', library);
				// console.log(this.userId)
				let inputJson;
				if (library.STATUS == "Active") {
					inputJson={"PROCEDURE":"removelibraryentry","USER_ID":this.userId,"LIBRARY_ID":library.LIBRARY_ID}

				} else{
					inputJson={"PROCEDURE":"activatelibraryentry","USER_ID":this.userId,"LIBRARY_ID":library.LIBRARY_ID}
				}
				
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS == 'Y') {
						library.STATUS = library.STATUS == "Active" ? "Inactive" : "Active";
					}else if (data.RESPONSE_STATUS == 'N') {
						// Swal.fire({
						// 	// title: data.MESSAGE,
						// 	html: `<p style="font-size:16px; color:red">${data.MESSAGE}</p>`,
						// })
						// console.log('changeLibraryStatus error:', data.MESSAGE);
						this.throwError(data);
					}
				});
			}
		}
		});
	}

	// This is for Repeat Fields:
	changeStatus(user) {
		console.log(user)

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID, "SLOT_ID":user.SLOT_ID, "FUNCTION_ID": 35};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson;
				if(user.STATUS == "Active"){
					//inputJson={"PROCEDURE":"removetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID}
					inputJson={"PROCEDURE":"RemoveSlot", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID, "SLOT_ID":user.SLOT_ID}

				}else{
					//inputJson={"PROCEDURE":"activatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}
					inputJson={"PROCEDURE":"ActivateSlot", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID, "SLOT_ID":user.SLOT_ID}
				}

				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS == 'Y') {
						user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
					}else if (data.RESPONSE_STATUS == 'N') {
						this.throwError(data);
					}
				});
				
			}
		}
		});

	}

	changeStatusCost(user){

		console.log(user)

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID, "SLOT_ID":user.SLOT_ID, "FUNCTION_ID": 35};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson;
				if(user.STATUS == "Active"){
					//inputJson={"PROCEDURE":"removetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":user.TEMPLATE_ID}
					inputJson={"PROCEDURE":"removecostlibraryentry","USER_ID":parseInt(this.userId),"COST_LIBRARY_ID":user.COST_LIBRARY_ID};

				}else{
					//inputJson={"PROCEDURE":"activatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}
					inputJson={"PROCEDURE":"activatecostlibraryentry","USER_ID":parseInt(this.userId),"COST_LIBRARY_ID":user.COST_LIBRARY_ID};
				}

				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS == 'Y') {
						user.STATUS = user.STATUS == "Active" ? "Inactive" : "Active";
					}
					else if (data.RESPONSE_STATUS == 'N') {
						this.throwError(data);
					}
				});
				
			}
		}
		});
			
	}

	changeTemplateStatus(template) {

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":template.TEMPLATE_ID, "FUNCTION_ID": 37};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				let inputJson;
				if (template.STATUS == "Active") {
					inputJson={"PROCEDURE":"removetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":template.TEMPLATE_ID}

				} else{
					inputJson={"PROCEDURE":"activatetemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":template.TEMPLATE_ID}
				}
				
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if (data.RESPONSE_STATUS == 'Y') {
						template.STATUS = template.STATUS == "Active" ? "Inactive" : "Active";
					}
					else if (data.RESPONSE_STATUS == 'N') {
						this.throwError(data);
					}
				});
			}
		}
		});
	}

  	public onInfo(e){
	  this.getUserDetail();
	}
	excelData;
	setExcel(event){
		console.log(event);
		if(event.filteredValue){
			this.excelData=event.filteredValue;
		}
	}
	deleteTemplate(){
		let inputJson= {"PROCEDURE":"deletetemplate", "USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID};
		this.reportService.univeralService(JSON.stringify(inputJson))
        .subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else {
			for(let i=0; i<this.allTemplates.length; i++){
				if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){	
					this.allTemplates.splice(i, 1);
					this.allTemplates = [].concat(this.allTemplates);
					}
			}
			console.log(data);
		}
		
	  		
		})
	}


	copyTemplate(include){

		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID,"FUNCTION_ID": 37};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson= {"PROCEDURE":"copytemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.templateRow.TEMPLATE_ID,"INCLUDE_SLOT":include}
				this.reportService.univeralService(JSON.stringify(inputJson))
				.subscribe(data => {
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
					  }else {
					console.log(data);
					console.log(data.TEMPLATE_TITLE)
					console.log(!data.TEMPLATE_TITLE)
					if(!data.TEMPLATE_TITLE){
						this.throwError(data);
					}
					
					for(let i=0; i<this.allTemplates.length; i++){
						if(this.allTemplates[i].TEMPLATE_ID==this.templateRow.TEMPLATE_ID ){
							this.allTemplates.splice(i, 0, data);
							if(this.allTemplates[i].TEMPLATE_TYPE[0]){
								this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].CATEGORY_NAME
								this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0].SUBCATEGORY_NAME
							}else{
								this.allTemplates[i].CATEGORY_NAME=''
								this.allTemplates[i].SUBCATEGORY_NAME=''
							}
							
					//		this.allTemplates = [].concat(this.allTemplates);
							break;
						}
					}
				}
				})

			}
		}
		});
	}
	async exportExcel(){
		this.loading=true;
		//this.excelData=this.libraryData;
		this.excelData=await this.getLibraries(parseInt(this.userId))
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		let i=1;
		for(let col of this.cols2){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let project of this.excelData){
			//let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				//for(let report of project.children){
					let arr=[];
					let i=1;
	
					for(let col of this.cols2){
					let obj={"col":i.toString(), "datavalue": 
					project[col.field]
					, "dtype":"string"};

					//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
						}
					
						i++
					}
					table.data.push({"row":arr});
					
			//	}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":"Library", "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
			this.ngZone.run(()=>{this.loading=false;})
		})


	}
	exportExcel1(){
		
		this.excelData=this.allTemplates;
		
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		let i=1;
		for(let col of this.templateCols){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let project of this.excelData){
			//let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				//for(let report of project.children){
					let arr=[];
					let i=1;
	
					for(let col of this.templateCols){
					let obj={"col":i.toString(), "datavalue": 
					project[col.field]
					, "dtype":"string"};

					//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
						}
					
						i++
					}
					table.data.push({"row":arr});
					
			//	}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":"Templates", "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
		})


	}
	typeListCols=[

		{ field: 'REPORT_TITLE', header: 'Report Title', width: '20%'},
		{ field: 'PROJECT_NUMBER', header: 'Project Number', width: '20%'},
		{ field: 'PROPERTY_NAME', header: 'Property Name', width: '20%'},
		{ field: 'ADDRESS_LINE1', header: 'Property Address', width: '20%'}, // perhaps also ADDRESS_LINE2
		{ field: 'CITY', header: 'Property City', width: '20%'},
		{ field: 'PROVSTATE', header: 'Property State / Province', width: '20%'},
		{ field: 'POSTALZIP', header: 'Property Zip / Postal Code', width: '20%'},
		{ field: 'TRANSACTION_TYPE', header: 'Transaction Type', width: '20%'},
		{ field: 'PROTOCOL', header: 'Protocol', width: '20%'},
		{ field: 'STATUS', header: 'Status', width: '20%'},
		{ field: 'LAST_UPDATED', header: 'Last Edited', width: '20%'},
	]

	companyGroupIndicator = false;
	getCompanyGroupIndicator() {
		let getcompanyinfoJson = { "PROCEDURE": "getcompanyprofile", "USER_ID": parseInt(this.userId) };
		this.reportService.univeralService(JSON.stringify(getcompanyinfoJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				return;
			}

			if (data.COMPANY_GROUP_IND === 'Y') {
				this.companyGroupIndicator = true;
				this.typeListCols.push({ field: 'REPORT_GROUP', header: 'Report Group', width: '20%'});
			} else {
				this.companyGroupIndicator = false;
			}
		});
	}

	excelTitle
	setExcelTitle(input){
		this.excelTitle = input
	}
	exportExcel2(){
		
		this.excelData=this.typeList;
		
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		// all good vv
		let i=1;
		for(let col of this.typeListCols){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}

		for(let project of this.excelData){
			//let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				//for(let report of project.children){
					let arr=[];
					let i=1;
	
					for(let col of this.typeListCols){
						let obj={"col":i.toString(), "datavalue":project[col.field], "dtype":"string"};

						if(col.field=="REPORT_GROUP"){
							obj.datavalue = obj.datavalue["GROUP_NAME"];
						}

						//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
						}
					
						i++
					}
					table.data.push({"row":arr});
					
			//	}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString() ,"filetitle":this.excelTitle, "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
		})


	}
	exportCostExcel(){
		this.excelData=this.allPCA;
		
		let table={"header":[
			// {"headername":"project id", "col":"1"},
			// {"headername":"project id", "col":"2"}
		   
		],
		"data":
		[
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"string"}]},
			// {"row":[{"col":"1", "datavalue":"xxx","dtype":"string"},{"col":"1", "datavalue":"xxx","dtype":"date"}]}
		]
		}
		let i=1;
		for(let col of this.pcaCols2){
			table.header.push({"headername":col.header, "col": i.toString()})
			i++
		}
		for(let project of this.excelData){
			//let first=true;
			// if(project.data.size==0){
			// 	for(let col of this.cols5){
			// 		let obj={"col":i, "datavalue":report.data[col.field], "dtype":"string"};

			// 		//	table.header.push({"headername":col.header, "col": i})

			// 			arr.push(obj);
			// 			i++
			// 		}
			// 		table.data.push({"row":arr});
			// }else{
				//for(let report of project.children){
					let arr=[];
					let i=1;
	
					for(let col of this.pcaCols2){
					let obj={"col":i.toString(), "datavalue": 
					project[col.field]
					, "dtype":"string"};

					//	table.header.push({"headername":col.header, "col": i})
						if(obj.datavalue){
							arr.push(obj);
						}
					
						i++
					}
					table.data.push({"row":arr});
					
			//	}
			
		}
		let inputJson={"USER_ID":parseInt(this.userId), "COMPANY_ID":this.userInfo.COMPANY_ID.toString(),"filetitle":"Library", "exceljson":JSON.stringify(table)};
		console.log("exportExcel", inputJson);
		this.reportService.genExcel(JSON.stringify(inputJson))
        .subscribe(data => {

			console.log(data);
			window.open(data.fileurl);
		})


	}
	newLibPara=[];
	libPara(e, index){
		//console.log(e)
		this.newLibPara[index]=e;//console.log(this.newLibPara);
		if(index==1){
			this.newLibPara0=e;
		}else if(index==3){
			this.newLibPara2=e;
		}
	}
	inputLabels='';
	title;
	addLibWarn=false;
	addLibWarnMessage = ''
	addLibrary(closeModal){
		this.addLibWarn=false;
		
		let instr='';
		let content='';
		let eleContent='';
		let eleInstruction='';
		let title=$("#titleID").val().trim();
		if(title.length==0){
			this.addLibWarnMessage = '* Title not valid'
			this.addLibWarn=true;
				return;
		}
		let that=this;
		const label=this.inputLabels;
		setTimeout(function(){
		if(that.newLibPara[0]){
			instr=that.newLibPara[0];
		}
		if(that.newLibPara[2]){
			content=that.newLibPara[2];
		}
		if(that.newLibPara[3]){
			eleContent=that.newLibPara[3];
		}
		if(that.newLibPara[0]){
			eleInstruction=that.newLibPara[1];
		}
		
	
		
		//let title = this.form.value.confirmTitle
		// "ITEM_TITLE":this.title
		let inputJson = {"PROCEDURE":"insertlibraryentry", "USER_ID":parseInt(that.userId),
						"ITEM_TITLE": title, "LABELS":label,
						"CONTENT":content, "INSTRUCTIONS":instr, 
						'CONTENT_HTML':eleContent, 'INSTRUCTIONS_HTML':eleInstruction };
		console.log(inputJson);

		that.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('insertlibraryentry', data);
			if(data.RESPONSE_STATUS == 'N'){
				that.addLibWarn=true;
				that.addLibWarnMessage = data.MESSAGE
				console.log(data.MESSAGE)
				that.throwError(data)
			}else{
				if(data.LABELS){
					data['ARRAYLABELS']=data.LABELS.split(';');
				}
				that.libraryData=[data, ...that.libraryData];
				that.formCheck=false;
				//that.clearLibraryForm();
				that.resetLibraryForm();
				that.totalLibraries = that.libraryData.length;
				if(closeModal){
					$('#reportsModal').modal('hide');
				}
				that.slotShow=false;
			}

		})	
	}, 500); 	
	}
	libraryToUpdate;
	newLibrary=true;
	
	updateTemplateTitlePermission = false;
	checkUpdateTemplateTitlePermission(template_id) {
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":template_id, "FUNCTION_ID": 38};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse);
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.updateTemplateTitlePermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { $('#updatetemplatetitle_op').modal('hide'); }, 250);
			} else {
				this.updateTemplateTitlePermission = true;
			}

		});
	}
	updateTemplateTitle(rowData){
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":rowData.TEMPLATE_ID, "TEMPLATE_TITLE":rowData.TEMPLATE_TITLE};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }
			// for(let i=0; i<this.allTemplates.length;i++){
			// 	if(this.allTemplates[i].TEMPLATE_ID==id){
			// 		this.allTemplates[i]=data;
			// 	}
			// }
		})
	}
	updateLibrary(){
		this.addLibWarn=false;
		let instr='';
		let content='';
		let eleContent='';
		let eleInstruction='';
		let title=$("#titleID").val().trim();
		if(title.length==0){
			this.addLibWarnMessage = '* Title not valid'
			this.addLibWarn=true;
			return			
		}
		const label=this.inputLabels;
		if(this.newLibPara[0]){
			instr=this.newLibPara[0];
		}
		if(this.newLibPara[2]){
			content=this.newLibPara[2];
		}
		if(this.newLibPara[3]){
			eleContent=this.newLibPara[3];
		}
		if(this.newLibPara[0]){
			eleInstruction=this.newLibPara[1];
		}
		let inputJson={"PROCEDURE":"updatelibraryentry", "USER_ID":parseInt(this.userId),  "LIBRARY_ID":this.libraryToUpdate.LIBRARY_ID, 
		"ITEM_TITLE":title, "CONTENT":content, "INSTRUCTIONS":instr, "LABELS":label, 'CONTENT_HTML':eleContent, 'INSTRUCTIONS_HTML':eleInstruction };
		console.log(inputJson);		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			content = ''
			instr = ''
			eleContent = ''
			eleInstruction = ''
			let copy=[...this.libraryData];
			if (data.RESPONSE_STATUS=='Y') {
				//data['ARRAYLABELS']=data.LABELS.split(';');
				let index=this.libraryData.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
				if(index>-1){
					this.libraryData[index]=data;
					this.libraryData[index].ARRAYLABELS=data.LABELS.split(';');
					copy[index]=data;	
					this.ngZone.run(()=>{
						this.libraryData=[...copy]
					})				
				}
				this.formCheck=false;
				this.clearLibraryForm();
				$('#reportsModal').modal('hide');
				this.slotShow=false;
			} else if (data.RESPONSE_STATUS == 'N') {
				this.addLibWarn=true;
				this.addLibWarnMessage = data.MESSAGE
				console.log(data.MESSAGE)
				this.throwError(data)
			}
		})
	}

	// saveNew(bool) { this.addLibrary(bool); this.newLibPara0 = ' '; this.newLibPara2 = ' '; }
	saveNew(bool) { this.addLibrary(bool); }
	saveUpdate() { setTimeout(() => { this.updateLibrary() }) }
	
	// saveNew(bool) { setTimeout(() => { this.addLibrary(bool) }) }
	// saveUpdate() { setTimeout(() => { this.updateLibrary() }) }

	slotToDelete;
	deleteSlotIndex;
	dismissConfirm5(event){
		$('#deleteModalPCA').modal('hide');
	}
	dismissConfirm2(event){
		$('#deleteModal').modal('hide');
	}
	dismissConfirm1(event){
		$('#deleteModal2').modal('hide');
	}
	dismissConfirm3(event){
		$('#deleteTempConfirm').modal('hide');
	}
	dismissConfirm4(event){
		$('#copyWith').modal('hide');
	}
	dismissConfirm(a){
		$(a).modal('hide');
	}
	selectedFilter4
	filterTemplates4(x){
		console.log("filtertemplates4",x)
		this.py.filter(x, 'STATUS', 'contains')
	}

	selectedFilter3
	filterTemplates3(x){
		//console.log("filtertemplates3",x)
		this.tt.filter(x, 'STATUS', 'contains')
	}
		newLibPara0
		newLibPara2
		deleteUser;
		deleteIndex;
	async fillLibrary(user){console.log(user)
		this.addLibWarn = false
		this.clearLibraryForm();
		await this.getLibContent(user);	
		this.title=user.ITEM_TITLE
		this.inputLabels=user.LABELS;
		this.newLibPara[0]=user.INSTRUCTIONS;
		this.newLibPara[1]=user.INSTRUCTIONS_HTML;
		this.newLibPara[2]= user.CONTENT; //console.log(this.newLibPara[2])
		this.newLibPara[3]=user.CONTENT_HTML;
		this.newLibPara0= this.newLibPara[0];
		if(user.CONTENT_HTML&&user.CONTENT_HTML.length>0){
			this.newLibPara2=  this.newLibPara[3];
		}else{
			this.newLibPara2=  this.newLibPara[2];
		}
		

	}

	test(){

		console.log('hii',this.libraryData);

	}
	
	manageLibraryPermission = false;
	checkManageLibraryPermission(library_id) {
		
		this.manageLibraryPermission = false;

		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId),"FUNCTION_ID": 34};
		if (library_id !== null) {
			checkUserInputJson["LIBRARY_ID"] = library_id;
		}
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.manageLibraryPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { 
					$('#reportsModal').modal('hide');
					$('#import').modal('hide');
					$('#costLibraryModal').modal('hide');
					$('#deleteModalPCA').modal('hide');
				}, 250);
			} else {
				this.manageLibraryPermission = true;
				
			}
		}
		});
	}
	clearLibraryForm(){
		this.addLibWarn = false
		this.PCAIdFiller={
			"Test": '',
			"Test1": ''
		}
		this.newLibPara = new Array(4);
		this.inputLabels='';
		$("#libLabel").val('');
		this.form.value.confirmTitle='';
		this.title='';

		// document.querySelectorAll("app-paragraph").forEach( elem => { elem.resetCKContent(); } );
		this.newLibPara0=' ';
		this.newLibPara2=' ';
		// console.log('test', this.newLibPara0)
		// console.log('test', document.getElementById('test'))
	}
	resetLibraryForm(){
		this.addLibWarn=false;
		this.PCAIdFiller={
			"Test": '',
			"Test1": ''
		}
		this.form.value.confirmTitle='';
		this.title='';
		$('#libLabel').val('');		
		this.inputLabels='';
		this.newLibPara[0]='';
		this.newLibPara[2]='';
		this.newLibPara[3]='';
		this.newLibPara[1]='';
		this.newLibPara0='';
		this.newLibPara2='';
	}
	removeIdentifier(id){

	}
	addIdentifier(id){

	}
	allTemplates=[];
	
	companyTemplatesLoading
	getCompanyTemplates(){
		this.companyTemplatesLoading = true
		let inputJson= {"PROCEDURE":"getcompanytemplates","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('companyTemplates',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allTemplates=data.RW_TEMPLATES;
			for(let i=0; i<this.allTemplates.length;i++){
				//console.log(this.allTemplates[i].TEMPLATE_TYPE[0], i);
				this.allTemplates[i].CATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.CATEGORY_NAME;
				this.allTemplates[i].SUBCATEGORY_NAME=this.allTemplates[i].TEMPLATE_TYPE[0]?.SUBCATEGORY_NAME;
				

			}	  	
			this.companyTemplatesLoading = false
		}
		})

	}
	getTemplateHistory(user){

		let inputJson={"PROCEDURE":"gettemplatehistory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":user.TEMPLATE_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			user.RW_TEMPLATE_HISTORY=data.RW_TEMPLATE_HISTORY;
			  }
		});
	}
	templateCounts;
	templateCountDict ={};
	getTemplateCounts(){
		let inputJson={"PROCEDURE":"gettemplatecounts","USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			console.log("templateCounts",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.templateCounts=data.TEMPLATE_COUNTS;
			this.templateFilterOptions.push(...data.TEMPLATE_COUNTS);
			console.log("this.templateFilterOptions",this.templateFilterOptions)
			for(let template of this.templateCounts){
				this.templateCountDict[template.SUBCATEGORY_NAME]=template.TOTAL;
			}
		}
		});
	}
  	getUserDetail(){
		if(this.cookieService.getCookie("userID")) {
			this.ngZone.run(()=>{this.loading=true;})
			this.userInfo=JSON.parse(this.cookieService.getCookie("userInfo"));
			console.log("firstuserinfo", this.userInfo)
						this.userId = this.cookieService.getCookie("userID");console.log(this.userId);
						this.r = this.cookieService.getCookie("r");
						this.userName = this.cookieService.getCookie("userName");console.log(this.userName);
            // this.getLibraries(this.userId);
            // this.getLibLabels(this.userId);
		//	this.getAllSlots();
			//this.getCompanyTemplates();
		//	this.getSlotPara();
			// this.getLibrariesSimple(parseInt(this.userId));
			//this.getLibraries(parseInt(this.userId));
			this.getLibrariesSimple(parseInt(this.userId))
			// this.getLibLabels(); // commented out to reduce oracle calls, called when needed
			// this.getSlotByType(parseInt(this.userId)); // commented out to reduce oracle calls, called when needed
			//this.getTableSlots(parseInt(this.userId));
			//this.getTableLib(parseInt(this.userId));
			//this.getAllSlots();
			//	this.getAllPCA();
		//	this.getTemplateCounts();
		//	this.getTemplateTypeCategory();
		} else {
			this.userId=null;			
		}
	}	

	allPCA=[];
	getAllPCA(){
		this.ngZone.run(()=>{this.loading=true;})
		let inputJson={"PROCEDURE":"getpcacostlibrary","USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('hehe',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allPCA=data.RW_PCA_COST_LIBRARY;
			this.totalPCA = data.RW_PCA_COST_LIBRARY.length;
			this.parseLabels2(); 
			
			  }	this.ngZone.run(()=>{this.loading=false;})	
		});

	}
	unit;
	units=[]
	getCostUnit(){
		let inputJson={"PROCEDURE":"getcostunit","USER_ID":parseInt(this.userId),}
		console.log("getcostunit", inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('cost units', data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.units=data.COST_UNITS
			  }
		});
	}
  //tableSlots;
  	allSlots=[];
  
  /*getTableSlots(id){
	let inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":id,"SLOT_TYPE":"Table"};
	this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		console.log(data);
		//this.tableSlots=data.RW_SLOTS;
		this.tempSlots=data.RW_SLOTS;
	})
}*/
	slotLoading
	totalSlots = 0;
	getAllSlots(){
		// let inputJson={"PROCEDURE":"getslots", "USER_ID":this.userId, "REPORT_ID":12};
    //let inputJson={"PROCEDURE":"getslots", "USER_ID":parseInt(this.userId),};
	let inputJson={"PROCEDURE":"GetCompanySlots", "USER_ID":parseInt(this.userId),};
		this.slotLoading = true
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allSlots=data.RW_SLOTS;
			this.totalSlots = this.allSlots.length;
			for(let i=0; i<this.allSlots.length;i++){
				if(this.allSlots[i].TYPE=="Table"){
					if(this.isJson(this.allSlots[i].CONTENT)){
						this.getTable2(this.allSlots[i]);
					}else{
						console.log(i, 'invalid table content')
					}
				}
			}
		}
			console.log('allslots', this.allSlots)
			this.slotLoading = false
		
		})
	}
	isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
	}
	slotsForLib=[];
	getSlotByType(id){
		let inputJson={"PROCEDURE":"getslotsbytypelist","USER_ID":id,"TYPE_LIST":"Narrative,Name,Monetory,Selection"}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotsForLib=data.RW_SLOTS;
			  }
		})
	}
	allLabels;
	getLibLabels(){console.log('hello')
		let inputJson={"PROCEDURE":"getlibrarylabels","USER_ID":parseInt(this.userId)};console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allLabels=data.RW_LABELS;
			  }
		})
	}
	allCostLabel;
	getCostLabels(){
		let inputJson={"PROCEDURE":"GetCostLibraryIdentifier","USER_ID":parseInt(this.userId)};console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.allCostLabel=data.RW_COST_LIBRARY_IDENTIFIERS;
			  }
		})
	}
	totalLibraries = 0
	totalPCA = 0
	async getLibraries(id){
		//this.getLibrariesSimple(id);
		let inputJson={"PROCEDURE":"getlibrary", "USER_ID":id};
		console.log(inputJson);
		const data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();//(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				//this.loading=false;
				return
			  }else{
				let info=data.RW_LIBRARY;
				return info
			  }
			 
			//this.libraryData=data.RW_LIBRARY;
	  		//this.totalLibraries = data.RW_LIBRARY.length;	 	 	
			//this.parseLabels();
			//console.log('total libraries', this.totalLibraries);
			  			//this.ngZone.run(()=>{this.loading=false;})
			
		//})
	}

	//for future reference

	getLibrariesSimple(id){
		let inputJson={"PROCEDURE":"getlibrarysimple", "USER_ID":id};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				this.loading=false;
			  }else{
			this.libraryData=data.RW_LIBRARY;
	  		this.totalLibraries = data.RW_LIBRARY.length;	 	 	
			this.parseLabels();
			console.log('total libraries simple', this.totalLibraries);
			  }
			this.ngZone.run(()=>{this.loading=false;})
		})
	}
	async getLibContent(lib){
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":lib.LIBRARY_ID};
		//console.log(inputJson);
		let data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
														
			}else{
				lib['CONTENT']=data.RW_LIBRARY[0].CONTENT;
				lib['CONTENT_HTML']=data.RW_LIBRARY[0].CONTENT_HTML;
				lib['INSTRUCTIONS']=data.RW_LIBRARY[0].INSTRUCTIONS;
				lib['INSTRUCTIONS_HTML']=data.RW_LIBRARY[0].INSTRUCTIONS_HTML;				
			}
	
	}
	getParagraphInfo(){

		this.newLibPara0 = '';

	}
	//curLibs;
	/*getLibRange(index){
		this.rangeIndex=index;
		if(index==0){
		  this.rangeLib=this.curLibs; 
		}else if(index==1){
		   this.rangeLib=this.libraryData; 
		}
		
		 
	}*/
	parseLabels(){
		this.libraryData.map((e)=>{//console.log(e)

			e.ARRAYLABELS= e.LABELS.split(';');
		})
		//this.libraryData =this.libraryData.LABELS.split(';');
		console.log("this.libraryData",this.libraryData)

	}
	parseLabels2(){
		this.allPCA.map((e)=>{

			e.ARRAYLABELS= e.IDENTIFIERS.split(';');
		})
		//this.libraryData =this.libraryData.LABELS.split(';');
		console.log("this.allPCA",this.allPCA)

	}
	removeLabel(library, index){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 34};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				let labels=library.LABELS.split(';');
				labels.splice(index, 1);
				let labeltext=labels.join(';');
				library.LABELS=labeltext;
				let inputJson= {"PROCEDURE":"updatelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":library.LIBRARY_ID, "LABELS":labeltext,}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);

					if (data.RESPONSE_STATUS == 'Y') {
						let index=this.libraryData.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
						if(index>-1){
							//this.libraryData[index]=data;
							this.libraryData[index].ARRAYLABELS=data.LABELS.split(';');
										
						}
					} else {
						this.throwError(data);
					}
				})
			}
		}
		});
	}
	
	removeLabelPCA(library, index){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 34};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				let labels=library.IDENTIFIERS.split(';');
				labels.splice(index, 1);
				let labeltext=labels.join(';');	
				library.IDENTIFIERS=labeltext;		
				let inputJson= {"PROCEDURE":"insertpcacostlibraryentry", "USER_ID":parseInt(this.userId), "COST_LIBRARY_ID":library.COST_LIBRARY_ID, "IDENTIFIERS":labeltext,}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if( data.RESPONSE_STATUS== "Y"){
					let index=this.allPCA.findIndex(pca=>pca.COST_LIBRARY_ID==data.COST_LIBRARY_ID); console.log(index)
						if(index>-1){
							this.allPCA[index].ARRAYLABELS=data.IDENTIFIERS.split(';');
						}	
					} else {
						this.throwError(data);
					}
				})
			}
		}
		});
		
	}
	// withinLines(check){
	// 	if(check.offsetHeight/check.style.lineHeight>3){

	// 	}
	// }
	removeLabel2(index){//console.log(index);
		let labels=this.inputLabels.split(';');
		labels.splice(index, 1);
		this.inputLabels=labels.join(';');
		//console.log(this.inputLabels);
	}
	removeLabelPCA2(index){console.log(index);
		let labels=	this.costLibraryForm.IDENTIFIERS.split(';');
		labels.splice(index, 1);
		this.costLibraryForm.IDENTIFIERS=labels.join(';');
		console.log(	this.costLibraryForm.IDENTIFIERS);
	}

	tableContent=[]
	getTable(data){console.log(data);
		this.tableContent=[];
		if(data.TYPE=='Table'){
			this.tableContent=JSON.parse(data.CONTENT).HEADERS;
		}else if(data.TYPE=='Selection'){
			//this.tableContent=data.split(';');
			this.tableContent=data.SELECTION_CHOICES.split(';;'); 			
		}
		console.log(this.tableContent);
	}
	getTable2(user){
		// console.log(user);
		user.tableContent=[];
		if(user.TYPE=='Table'){
			user.tableContent=JSON.parse(user.CONTENT).HEADERS;
		}else if(user.TYPE=='Selection'){
			user.tableContent=user.SELECTION_CHOICES.split(';;'); 
			
		}
		// console.log(user.tableContent);
	}
	addLabel(library, x){
		let labels=library.LABELS.split(';');
		if(x==2){
				let text=library["toAddLabel"+x]
				let arr=text.split(';');
				for (let ar of arr) {
					if(ar.trim().length>0){
						labels.push(ar.trim());
					}
				}
				
			
		}
		else{
			labels.push(library["toAddLabel"+x]);
		}

		let labelstext=labels.join(';');
		library.LABELS=labelstext;
		let inputJson= {"PROCEDURE":"updatelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":library.LIBRARY_ID, "LABELS":labelstext,}
		library.toAddLabel=null;
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }
			console.log(data);

		})
	}
	addLabelPCA(library, x){
		let labels=library.IDENTIFIERS.split(';');
		if(x==2){
				let text=library["toAddLabel"+x]
				let arr=text.split(';');
				for (let ar of arr) {
					if(ar.trim().length>0){
						labels.push(ar.trim());
					}
				}
			
		}else{
			labels.push(library["toAddLabel"+x]);
		}
		
		let labelstext=labels.join(';');
		library.IDENTIFIERS=labelstext;
		let inputJson= {"PROCEDURE":"insertpcacostlibraryentry", "USER_ID":parseInt(this.userId), "COST_LIBRARY_ID":library.COST_LIBRARY_ID, "IDENTIFIERS":labelstext,}
		library.toAddLabel=null;
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }
			console.log(data);

		})
	}
	/*addLabel2(e){
		let text=$(e.target).prev('input').val(); console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				this.inputLabels+=ar.trim()+';';
			}
		}
		$(e.target).prev('input').val('');
	}*/
	PCAIdentifierClear(){
		document.getElementById('PCA Id Clear')
	}
	
	updateInstructions(){

	}
	deleteLibrary(library, index){

		let inputJson= {"PROCEDURE":"deletelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":library.LIBRARY_ID}
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if( data.RESPONSE_STATUS== "Y"){
				console.log("MESSAGE", data.MESSAGE);
				this.totalLibraries = this.totalLibraries - 1;
				let index=this.libraryData.findIndex(lib=>lib.LIBRARY_ID==library.LIBRARY_ID); console.log(index)
				if(index>-1){
					let copy=[...this.libraryData];
					copy.splice(index,1);
					this.ngZone.run(()=>{
						this.libraryData=[...copy]
					})	
				}	
			}else{
				this.throwError(data)
			}
		})

	}
	PCAIdFiller={
		"Test": '',
		"Test1": ''
	}
	costLibraryForm={
		"ITEM_TITLE": '',
		"EUL":'',
		"COST":'',
		"UNIT":'',
		'IDENTIFIERS':''
	}
	newCostLibrary=false;
	costlibraryToUpdate;
	fillCostLibrary(user){console.log(user)
		this.resetCostLibrary();
		
		this.costLibraryForm=user;
		this.costLibraryForm.IDENTIFIERS=user.IDENTIFIERS;
		this.title=user.ITEM_TITLE;
		this.costLibraryForm.IDENTIFIERS=user.IDENTIFIERS;

	}
	updateCostLibrary(){
		if(this.costLibraryForm.ITEM_TITLE.length==0){
			this.addCostWarnMessage = '* Title not valid'
			this.addCostWarn=true;
				return			
		}
		if(this.form1.value.confirmCostTitle){
		
		let inputJson={"PROCEDURE":"insertpcacostlibraryentry", "COST_LIBRARY_ID": this.costlibraryToUpdate.COST_LIBRARY_ID,"USER_ID":parseInt(this.userId),...this.costLibraryForm}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS == 'N'){
				this.addCostWarn=true;
				this.addCostWarnMessage = data.MESSAGE
				console.log(data.MESSAGE)
				this.throwError(data);
				return
			}
			if( data.RESPONSE_STATUS== "Y"){
			$('#costLibraryModal').modal('hide');
			let index=this.allPCA.findIndex(pca=>pca.COST_LIBRARY_ID==data.COST_LIBRARY_ID); console.log(index)
				if(index>-1){
					let copy=[...this.allPCA];
					this.allPCA[index]=data;console.log(data)
					this.allPCA[index]['ARRAYLABELS']=data.IDENTIFIERS.split(';');
					copy[index]=data;	
					this.ngZone.run(()=>{
						this.allPCA=[...copy]
					})	
				}		
			this.resetCostLibrary();
			this.formCheck=false;}
		})
		}	
		
	}
	resetCostLibrary(){
		this.addCostWarn = false
		this.PCAIdFiller={
			"Test": '',
			"Test1": ''
		}
		this.costLibraryForm={
			"ITEM_TITLE": '',
			"EUL":'',
			"COST":'',
			"UNIT":'',
			'IDENTIFIERS':''
		}
	}
	error=false;
	addCostWarn
	addCostWarnMessage
	addCostLibrary(){
		console.log(this.costLibraryForm.ITEM_TITLE.length)
		
		if(this.costLibraryForm.ITEM_TITLE.length==0){
			this.addCostWarnMessage = '* Title not valid'
			this.addCostWarn=true;
				return			
		}
		console.log(this.form1.value.confirmCostTitle)
		if(this.form1.value.confirmCostTitle){
	let inputJson={"PROCEDURE":"insertpcacostlibraryentry","USER_ID":parseInt(this.userId),...this.costLibraryForm}
	
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS == 'N'){
				this.addCostWarn=true;
				this.addCostWarnMessage = data.MESSAGE
				console.log(data.MESSAGE)
				this.throwError(data)
				return
			}
			if(data.RESPONSE_STATUS == 'Y'){
			$('#costLibraryModal').modal('hide');
			console.log(data);
			data['ARRAYLABELS']=data.IDENTIFIERS.split(';');
			this.allPCA=[data, ...this.allPCA];
		//this.rangeLib=this.libraryData
			//this.parseLabels2();
			this.resetCostLibrary();
			this.formCheck=false;
			this.totalPCA = this.allPCA.length;	
			}				
		})
		}	
		
		
	}
	
		deleteCostLibrary(library, index){

		let inputJson= {"PROCEDURE":"deletepcacostlibrary", "USER_ID":parseInt(this.userId), "COST_LIBRARY_ID":library.COST_LIBRARY_ID}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
		 	console.log(data);
			if( data.RESPONSE_STATUS== "Y"){
				this.totalPCA = this.totalPCA - 1
				let index1=this.allPCA.findIndex(pca=>pca.COST_LIBRARY_ID==library.COST_LIBRARY_ID); console.log(index1)
				if(index1>-1){
					let copy=[...this.allPCA];
					copy.splice(index1,1);
					this.ngZone.run(()=>{
						this.allPCA=[...copy]
					})
				}	
			}else{
				
					this.throwError(data)
				  
			}

		})

	}
	changeLibraryDetails(type, library){
		let inputJson = { "PROCEDURE": "updatelibraryentry", "USER_ID": parseInt(this.userId), "LIBRARY_ID":library.LIBRARY_ID}
		inputJson[type]=library[type+"_TOEDIT"];
		library[type]=library[type+"_TOEDIT"];
		console.log('changeUserDetails', inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }
			console.log(data);
		});
	}
	deleteSlot(slot, index){
		let inputJson ={"PROCEDURE":"deleteslot","USER_ID":parseInt(this.userId),"SLOT_ID":slot.SLOT_ID};

		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				this.allSlots.splice(index, 1);		
				this.totalSlots = this.allSlots.length;	
			}else{
				this.throwError(data);
			}
			
	  	
		});

	}
	newSlotLabel;
	newSlotCat;
	newSlotType;
	newSlotMultiple="N";
	newSlotFile={'url':'', 'name':'', 'ext':''};
	newSlotContent;
	newSlotOp;
	filteredData=[];
	missingSlot=false;
	missingSlotMessage=''
	createSlot(e){
		//if(this.newSlotLabel&&this.newSlotLabel.trim().length>0&&this.newSlotCat.length>0){ 
		if(!(this.newSlotType.length==0||this.newSlotLabel.trim()=== ''||this.newSlotCat.trim().length==0||(this.newSlotType=='Selection'&&this.newSlotOps.length==0)||(this.newSlotType=='File'&&this.newSlotFile.url.length==0))){
			this.missingSlot=false;
			let id=null;
			let slotContent='';
			let opContent='';
			let ext="";
			let name='';
			if(this.newSlotType=='Selection'){
				opContent=this.newSlotOps.join(';;');
				/*if(this.newSlotMultiple=='Y'){
					slotContent=opContent;
				}else{
					slotContent=this.newSlotOps[0];
				}*/
			}else if(this.newSlotType=='File'){
				if(this.newSlotFile.url.length>0){
					slotContent=this.newSlotFile.url;
					ext=this.newSlotFile.ext;
					name=this.newSlotFile.name;
				}				
			}else{
				slotContent=this.newSlotContent;
			}
			console.log(slotContent);
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id, "KEY":this.newSlotLabel, "TYPE":this.newSlotType, "CONTENT":slotContent,"CATEGORY":this.newSlotCat};
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent};
			let inputJson:any;
			if(this.newSlotType=='File'){
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent, "FILE_EXTENSION":ext, "FILE_NAME":name};
			}else{
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent};
			}
			
			console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
				let info=JSON.parse(data);
				

				if(info.RESPONSE_STATUS == "N"){
					this.missingSlot=true
					this.missingSlotMessage = info.MESSAGE
					console.log(info.MESSAGE)
					this.throwError(data)
					return
				}
				if( info.RESPONSE_STATUS == "Y"){
					this.resetSlotForm();
			$('#reportsModal2').modal('hide');
				/*let item={'CATEGORY': info.CATEGORY,
				'CONTENT': info.CONTENT,
				'KEY': info.KEY,
				'SLOT_ID': info.SLOT_ID,
				'TYPE': info.TYPE,
				"TEMPLATE_ID":info.TEMPLATE_ID,
		}*/
				//this.selectedSlot=JSON.parse(data);
				//this.allSlots=[item, ...this.allSlots];
				this.allSlots.unshift(info);
		//	this.curTemp.TOTAL_SLOTS+=1;
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
			Toast.fire({
					icon: 'success',
					title: 'saved'
				})
			this.resetSlotForm();
			this.totalSlots = this.allSlots.length;
			}
		})
		} else {
			this.missingSlot=true
			this.missingSlotMessage = "* "
			if(this.newSlotLabel.trim()==""){
				this.missingSlotMessage = this.missingSlotMessage + "Identifier"
			}
			if(this.newSlotCat.trim()==''){
				if(this.newSlotLabel.trim()==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Category"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Category"
				}
			}
			if(this.newSlotType==''){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotLabel==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Type"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Type"

				}
			}
			if(this.newSlotType=='Selection'&&this.newSlotOps.length==0){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotType==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Selection"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Selection"

				}
			}
			if(this.newSlotType=='File'&&this.newSlotFile.url.length==0){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotType==""){
					this.missingSlotMessage = this.missingSlotMessage + ", File"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "File"

				}
			}
			this.missingSlotMessage = this.missingSlotMessage + " not valid"
		}
	}
	createSlot1(){
		//if(this.newSlotLabel&&this.newSlotLabel.trim().length>0&&this.newSlotCat.length>0){ 
		if(!(this.newSlotType.length==0||this.newSlotLabel.trim()=== ''||this.newSlotCat.trim().length==0||(this.newSlotType=='Selection'&&this.newSlotOps.length==0)||(this.newSlotType=='File'&&this.newSlotFile.url.length==0))){
			this.missingSlot=false;
			let id=null;
			let slotContent='';
			let opContent='';
			let ext="";
			let name='';
			if(this.newSlotType=='Selection'){
				opContent=this.newSlotOps.join(';;');
				/*if(this.newSlotMultiple=='Y'){
					slotContent=opContent;
				}else{
					slotContent=this.newSlotOps[0];
				}*/
			}else if(this.newSlotType=='File'){
				if(this.newSlotFile.url.length>0){
					slotContent=this.newSlotFile.url;
					ext=this.newSlotFile.ext;
					name=this.newSlotFile.name;
				}				
			}else{
				slotContent=this.newSlotContent;
			}
			console.log(slotContent);
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id, "KEY":this.newSlotLabel, "TYPE":this.newSlotType, "CONTENT":slotContent,"CATEGORY":this.newSlotCat};
			//let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent};
			let inputJson:any;
			if(this.newSlotType=='File'){
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent, "FILE_EXTENSION":ext, "FILE_NAME":name};
			}else{
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent};
			}
			//this.resetSlotForm();
			//$('#reportsModal2').modal('hide');
			console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
				let info=JSON.parse(data);

				if(info.RESPONSE_STATUS == "N"){
					this.missingSlot=true
					this.missingSlotMessage = info.MESSAGE
					console.log(info.MESSAGE)
					this.throwError(data)
				}
				if( info.RESPONSE_STATUS == "Y"){
				
				this.resetSlotForm()
				/*let item={'CATEGORY': info.CATEGORY,
				'CONTENT': info.CONTENT,
				'KEY': info.KEY,
				'SLOT_ID': info.SLOT_ID,
				'TYPE': info.TYPE,
				"TEMPLATE_ID":info.TEMPLATE_ID,
		}*/
				//this.selectedSlot=JSON.parse(data);
				//this.allSlots=[item, ...this.allSlots];
				this.allSlots.unshift(info);
		//	this.curTemp.TOTAL_SLOTS+=1;
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
			Toast.fire({
					icon: 'success',
					title: 'saved'
				})
			this.resetSlotForm();
			this.totalSlots = this.allSlots.length;
			}
		})
		} else {
			this.missingSlot=true
			this.missingSlotMessage = "* "
			if(this.newSlotLabel.trim()==""){
				this.missingSlotMessage = this.missingSlotMessage + "Identifier"
			}
			if(this.newSlotCat.trim()==''){
				if(this.newSlotLabel.trim()==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Category"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Category"
				}
			}
			if(this.newSlotType==''){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotLabel==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Type"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Type"

				}
			}
			if(this.newSlotType=='Selection'&&this.newSlotOps.length==0){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotType==""){
					this.missingSlotMessage = this.missingSlotMessage + ", Selection"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Selection"

				}
			}
			if(this.newSlotType=='File'&&this.newSlotFile.url.length==0){
				if(this.newSlotLabel.trim()==''||this.newSlotCat.trim()==''||this.newSlotType==""){
					this.missingSlotMessage = this.missingSlotMessage + ", File"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "File"

				}
			}
			this.missingSlotMessage = this.missingSlotMessage + " not valid"
		}
	}

	manageRepeatFieldPermission = false;
	checkManageRepeatFieldPermission(slot_id) { // may need to accept slot_id later
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 35};
		if (slot_id !== null) {
			checkUserInputJson["SLOT_ID"] = slot_id;
		}
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.manageRepeatFieldPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { $('#reportsModal2').modal('hide'); }, 250);
			} else {

				this.manageRepeatFieldPermission = true;

			}
		}
		});
	}
	showRepeatFields(){
		this.newSlot=true;
		this.missingSlot=false;
		this.missingSlotMessage='';
		this.newSlotLabel='';
		this.newSlotContent='';
		this.newSlotCat='';
		this.newSlotType='';
		this.newSlotOps=[];
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
		this.newSlotMultiple='N';
	}
	newSlot=true;
	filteredArrayVar
	filteredArray(input){
		this.filteredArrayVar = input
	}
	consoleLog(input){
		console.log(input)
	}
	rowIndex
	getRowIndex(index){
		this.rowIndex = index
	}
	fillSlotForm(user){
		console.log(this.py)
		this.missingUpdate = false
		this.missingUpdateMessage = ""
		console.log('SLOT CATEGORY', this.newSlotType)
		console.log("user",user)
		this.newSlotContent=user.CONTENT;
		console.log("this.newSlotContent",this.newSlotContent)
		this.newSlotLabel=user.KEY;
		this.newSlotType=user.TYPE;
		this.newSlotCat=user.CATEGORY;
		if(user.TYPE=="Selection"){
			this.newSlotOps=user.SELECTION_CHOICES.split(';;')
			console.log("this.newSlotOps",this.newSlotOps)
		}
		if(user.TYPE=="File"){
			//this.newSlotFile.url=user.CONTENT
			this.newSlotContent = ''
			this.newSlotFile.name=user.FILE_NAME
			this.newSlotFile.url=user.CONTENT
		}
		
	
	}
	updateSlotIndex;
	slotToUpdate;
	missingUpdateMessage
	missingUpdate
	updateSlot(){
		//console.log(this.py.filteredValue)
		//console.log(this.py.filteredValue[this.rowIndex])
		console.log(this.newSlotMultiple)
		let slotContent;
		let selectionChoices
		let slotEXT
		let slotFileName
		this.missingUpdate = false
		console.log(this.newSlotOps)
		if(this.newSlotType=='File'){
			// console.log(this.newSlotFile)
			// console.log(this.newSlotFile.ext)
			// console.log(this.newSlotFile.url)
			console.log(this.newSlotFile.name)
			slotContent = this.newSlotFile.url
			slotEXT = this.newSlotFile.ext
			slotFileName = this.newSlotFile.name
			if(slotFileName==''){
				this.missingUpdate = true
				this.missingUpdateMessage = 'File required'
				// console.log(this.newSlotFile)
				// console.log(this.newSlotFile.ext)
				// console.log(this.newSlotFile.url)
				// console.log(slotFileName)
			}
		}
		else if(this.newSlotType=='Selection'){ //if
			if(this.newSlotOps.length==0){
				this.missingUpdate = true
				this.missingUpdateMessage = "Option can not be empty"
			}
			//slotContent=this.newSlotOps.join(',');
			selectionChoices=this.newSlotOps.join(';;') 
		}else{
			slotContent=this.newSlotContent;
		}

		if(this.missingUpdate!=true) {
		let inputJson={
		"PROCEDURE":"updateslotcontent",
		"CATEGORY":this.newSlotCat,
		"USER_ID":parseInt(this.userId),
		"SELECTION_CHOICES":selectionChoices,
		"SLOT_ID":this.slotToUpdate.SLOT_ID,
		"SLOT_CONTENT":slotContent,
		"FILE_EXTENSION":slotEXT,
		"FILE_NAME":slotFileName,
		"MULTIPLE_CHOICE":this.newSlotMultiple
		};
		$('#reportsModal2').modal('hide');
		this.resetSlotForm();
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			let info=JSON.parse(data);
			let index=this.py._value.findIndex(slot=>slot.SLOT_ID==info.SLOT_ID); console.log(index)
			if(index>-1){
				console.log(this.allSlots[index])
				console.log(info)
				this.py._value[index]=info;
			}	
			if(this.py.filteredValue!=undefined){
				//this.py.filteredValue[this.rowIndex] = info

				let index2=this.py.filteredValue.findIndex(slot=>slot.SLOT_ID==info.SLOT_ID); console.log(index2)
				if(index2>-1){
					console.log(this.allSlots[index2])
					console.log(info)
					this.py.filteredValue[index2]=info;
				}
		}
	}
			//this.getAllSlots()
		})
	}
	
	}
	expanded=false;
	expandcollapse(){
		this.expanded=!this.expanded;
	}
	clearSlotForm(){
		this.newSlotContent='';
		this.newSlotMultiple='N';
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
		this.newSlotLabel='';
		this.newSlotType='';
		this.newSlotCat='';
		this.newSlotOp='';
	}
	addOpItem(evet){
		if(this.newSlotOp.length>0){
			this.newSlotOps.push(this.newSlotOp)
			this.newSlotOp='';
			//$('.slotBtn')[1].classList.add("disabled"); 
		}
	}
	clearOpItem(){
		this.newSlotOps=[];
		$('.slotBtn').each(function(){
			if($(this).hasClass('disabled')){
				$(this).removeClass('disabled');
			}
		})
	}
	onEditReport(e){
		
	} 
	logoInfo;
	/*private getLogo(){
		let inputJson={"PROCEDURE":"getcompanylogo","CUSTOMER_ID":parseInt(this.userId)};
		this.reportService.logouniveralService(inputJson).subscribe(data => {console.log(data);
			
			this.logoInfo=data;
		})
	}*/
	slotToLib;
	selectedSlot
	curLib=[];
	curLibId=[];
	slotShow=false;
	addSlotPrep(){
		this.slotToLib=true;
		this.filteredData=null;
		this.selectedSlot=[];
		this.curLib=[];
		this.curLibId=[];
		this.slotShow=true;
		this.getSlotByType(parseInt(this.userId));
	}
	curSlot=[];
	curSlotId=[];
	selSlot(item){console.log(item)
		let index=this.curSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
		if(index>-1){
			this.curSlot.splice(index,1);
			this.curSlotId.splice(index,1);
		}else{
			this.curSlot.push(item);
			this.curSlotId.push(item.SLOT_ID);
		}	
		console.log(this.curSlotId)
	}
	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.selectedSlot, event.previousIndex, event.currentIndex);
	  }
	slotCategories;
	slotTypes;
	getSlotPara(){
		let inputJson={"PROCEDURE":"getslotcategories","USER_ID":parseInt(this.userId)};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotCategories=data.RW_SLOT_CATEGORIES;
			  }			
		})
	}
	getslotType(){
		let inputJson={"PROCEDURE":"getslottypes","CREATE_NEW_RF":"Y"};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotTypes=data.RW_SLOT_TYPES;
			  }			
		})
	}
	itemIndex=0;
	addedItem;
	libToSlot;
	addRepeat(type, item){console.log(type, item);
		let content='';
		if(type=='slot'){
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.itemIndex++;	
			this.addedItem={'index':this.itemIndex,'content':content, 'type':type};console.log(this.addedItem);
			
		}else if(type=='newLib'){
			let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.itemIndex++;	
			this.addedItem={'index':this.itemIndex,'content':content, 'type':'slot'};console.log(this.addedItem);
			
		}			
	}
	addSlotToLib(){
		/*console.log("addSlotToLib")
		let item=this.newSlotLabel=[0];
		let content='';
		let obj={'name':item.KEY, 'dataId':item.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.itemIndex+=this.itemIndex;	
			this.addedItem={'index':this.itemIndex,'content':content, 'type':'slot'};console.log(this.addedItem);

		$('#addSlotModal').modal('hide');*/
	}
	resetSlotForm(){
		this.newSlotLabel=[];
		this.newSlotCat="";
		this.newSlotType="";
		this.newSlotContent="";
		this.newSlotOps=[];
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
	}
	cancleSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
		$('#addSlotModal').modal('hide');
	}
	selectedCell;
	addSlot(){console.log(this.selectedSlot)
		/*let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]['slots']=this.selectedSlot;
		}else if(index2>-1){
			this.contents[index1].SUB_SECTIONS[index2]['slots']=this.selectedSlot;;
		}else if(index1>-1){
			this.contents[index1]['slots']=this.selectedSlot;
		}*/
		let content='';
		let data:any
		if(this.selectedCell){
			for(let item of this.selectedSlot){
				let itemHtml='<span>'+item.CONTENT+', '+'</span>';
				content+=itemHtml; 
				data=content;
			}
		}else{
			for(let item of this.selectedSlot){
				let itemHtml='<span style="background-color:#ffffff;">'+item.CONTENT+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
				content+=itemHtml; 
			}
			console.log(content);
			this.itemIndex+=this.itemIndex;
			data={'index':this.itemIndex,'content':content}
		}
		this.toContentData('addedItem', data, 'addSlotModal');
		//$('#addSlotModal').modal('hide');
		this.selectedSlot=[];		
	}

	curIndex;
	contents;
	toContentData(field, data, pop){console.log(this.curIndex);
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(!this.selectedCell){			
			if(index3>-1){
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][field]=data;
			}else if(index2>-1){
				this.contents[index1].SUB_SECTIONS[index2][field]=data;console.log(data);
			}else if(index1>-1){
				this.contents[index1][field]=data;
			}
		}else{console.log(this.selectedCell)
			if(index3>-1){
				if(data instanceof Array){
					this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					if(this.selectedCell.row!=null){
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.cols[this.selectedCell.col].NAME=data
					}
					//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].name=data
				}
			}else if(index2>-1){console.log(this.contents[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data; console.log(data)
				}else{console.log(this.selectedCell.row);
					if(this.selectedCell.row!=null){
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
	}
	clearAddedSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
	}
	rmvAddedSlot(){
		for(let item of this.curSlot){
			let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
			if(index>-1){
				this.selectedSlot.splice(index,1);
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	// slots=[];
	addAllSelSlot(){
		console.log("addAllSelSlot")
		if(this.allSlots.length<11&&!this.filteredData){
			for(let fslot of this.allSlots){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
			
		}else if(this.filteredData&&this.filteredData.length<11){
			for(let fslot of this.filteredData){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}

	addSelSlot(){
		console.log("addSelSlot")
		if(this.curSlot.length>0){
			for(let item of this.curSlot){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(item);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
		
	}
	//rangeIndex;
	//rangeSlot;
	//curSlots;
	//tempSlots;
	/*getSlotRange(index){//console.log(index)
	  
		this.rangeIndex=index;
		if(index==0){
		  this.rangeSlot=this.curSlots; 
		}else if(index==1){
		   this.rangeSlot=this.tempSlots; 
		}else if(index==2){
		  this.rangeSlot=this.allSlots;  
		}
		console.log(index);
		console.log(this.rangeSlot);
		//console.log(this.rangeSlot);
		console.log(this.selectedSlot);
		 
	}*/
	onFilter(event, dt) { 
		this.filteredData = event.filteredValue; console.log(this.filteredData);
	}
	async selLib(item){console.log(item)
		await this.getLibContent(item);
		let index=this.curLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
		if(index>-1){
			this.curLib.splice(index,1);
			this.curLibId.splice(index,1);
		}else{
			this.curLib.push(item);
			this.curLibId.push(item.LIBRARY_ID);
		}
				
	}
	addedLib=[];
	libLabels=[];
	addSelLib(){
		if(this.curLib.length>0){
			for(let item of this.curLib){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(item);
				}
			}
			this.curLib=[];
			this.curLibId=[];	
		}
		
	}
	async addAllSelLib(){console.log(this.addedLib);
	console.log(this.filteredData)
		if(this.libLabels.length<11&&!this.filteredData){
			for(let flib of this.libLabels){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}				
			}
		}else if(this.filteredData&&this.filteredData.length<11){
			//this.addedLib = [...this.addedLib, ...this.filteredData]; console.log(this.addedLib);
			for(let flib of this.filteredData){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}
			}
		}
		this.curLib=[];
		this.curLibId=[];	
	}
	rmvAddedLib(){
		for(let item of this.curLib){
			let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.addedLib.splice(index,1);
			}
		}
		this.curLib=[];
		this.curLibId=[];
	}
	clearAddedLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];		
	}
	cancleLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
		$('#libraryModal').modal('hide');
	}
	dropLib(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.addedLib, event.previousIndex, event.currentIndex);
	  }
	  newSlotOps=[];
	  addLibToSlot(){
		if(this.newSlotType=='Selection'){
			this.newSlotOps=[];
			for(let lib of this.addedLib){
				this.newSlotOps.push(lib.CONTENT);
			}
			$('.slotBtn')[0].classList.add("disabled"); 
		}else{
			this.newSlotContent="";
			for(let lib of this.addedLib){
				this.newSlotContent+=lib.CONTENT;
			}
		}
		$('#libraryModal').modal('hide');
		this.resetLib();
	}
	
	resetLib(){
		this.addedLib=[];
		this.filteredData=null;
	}
	secSetting(e){
		//e.stopPropagation();
	}
	addLibToDoc(){
		/*let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]['libs']=this.addedLib;
		}else if(index2>-1){
			this.contents[index1].SUB_SECTIONS[index2]['libs']=this.addedLib;;
		}else if(index1>-1){
			this.contents[index1]['libs']=this.addedLib;
		}*/
		let content='';
		let data:any
		if(this.selectedCell){
			for(let item of this.addedLib){
				let itemHtml='<p>'+item.CONTENT+'</p>';
				content+=itemHtml; 
				data=content;
			}
		}else{
			for(let item of this.addedLib){
				let itemHtml='<span style="background-color:#ffffff;">'+item.CONTENT+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
				content+=itemHtml; 
			}
			console.log(content);
			this.itemIndex+=this.itemIndex;
			data={'index':this.itemIndex,'content':content};
		}
		this.toContentData('addedItem', data, 'libraryModal');
		this.resetLib();
		this.clearAddedLib();
	}

	hasDuplicates(array) {
		return (new Set(array)).size !== array.length;
	}
	excelCols;
	alphaOrder(arr){

		return(arr.sort(function(a, b){
			return a === b ? 0 : a > b ? 1: -1;
		}));
	}
	presetCols2=["CONTENT", "ITEM_TITLE", "INSTRUCTIONS", "IDENTIFIERS", "CONTENT_HTML", "INSTRUCTIONS_HTML","LIBRARY_ID"];
	//presetCols=["CONTENT", "TITLE", "INSTRUCTIONS", "IDENTIFIERS", "CONTENT_HTML", "INSTRUCTIONS_HTML","LIBRARY_ID"];
	presetCols=['CONTENT', 'CONTENT_HTML', 'IDENTIFIERS', 'INSTRUCTIONS', 'INSTRUCTIONS_HTML', 'LIBRARY_ID', 'TITLE']
	presetCostCols=["COST_LIBRARY_ID", "TITLE", "IDENTIFIERS","EUL", "COST" , "UNIT",  ];
	presetCostCols2=["COST_LIBRARY_ID", "ITEM_TITLE", "IDENTIFIERS","EUL", "COST" , "UNIT",  ];
	excelJson;

	sheets=[];
	rawExcelJson;
	excelArray
	selectedSheet;
	sheet1;
	resetUpload(){
		console.log('Excel', this.sheet1)
		this.sheet1=''
		this.excelJson=null; this.excelCols=[];
		this.rawExcelJson=null;
		this.excelArray=null;
		this.sheets=[];
		this.selectedSheet='';

	}
	resetSheet(){
		this.excelJson=null; this.excelCols=[]; ;
		//this.rawExcelJson=null;
		this.excelArray=null;
	}
	uploadExcel(){	
		console.log("uploadExcel")

		let that=this;
		const file = this.excelFile.nativeElement.files[0];
		console.log(file)
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
    //this.fileReader.readAsDataURL(file);
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			const data = reader.result;
			let workBook = XLSX.read(data, { type: 'binary' });
			let jsonData = workBook.SheetNames.reduce((initial, name) => {
			  const sheet = workBook.Sheets[name];
			  initial[name] = XLSX.utils.sheet_to_json(sheet);
			  return initial;
			}, {});
			//const dataString = JSON.stringify(jsonData);
			console.log(jsonData);

			for(var key in jsonData){
				if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
					that.sheets.push(key);
				}
			}
			that.selectedSheet=that.sheets[0]
			that.rawExcelJson=jsonData;
			that.resetSheet();
			that.selectSheet()

		
		  }
		  reader.readAsBinaryString(file);
		if(!this.excelFile.nativeElement.files[0]){
			let data={"MESSAGE":'Please upload a file.'};
			this.throwError(data);
			return;
		}
	}
	
	selectSheet(){
		let array=[];
		for(let project of this.rawExcelJson[this.selectedSheet]){
			for (var key in project) {
				if (Object.prototype.hasOwnProperty.call(project, key)) {
				
						array.indexOf(key) === -1 ? array.push(key) : console.log("");
				//	}
					
				}
			}
		}
		this.excelArray=array;
		for(let col of array){

			this.excelCols.push({'header':col, "changeHeader":col});
		}
		console.log("excel cols", this.excelCols)
		this.excelJson=this.rawExcelJson[this.selectedSheet];
		//that.uploadBatchProjects(jsonData['Sample Data']);
	}
	costUpload=false;

	loading=false;
	uploadBatchProjects(){
		if(!this.costUpload){
			this.ngZone.run(()=>{this.loading=true;})
			let inputJson={"PROCEDURE":"batchuploadlibrary","USER_ID":parseInt(this.userId), "RW_LIBRARIES":this.excelJson}

			console.log(inputJson);
			
			console.log("excel cols", this.excelCols)
			let array=[];
			for(let col of this.excelCols){
		
				array.push(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader);
				
			}
			console.log("array", array)
			if(!array.every(val => this.presetCols2.includes(val))|| this.hasDuplicates(array)){
				this.ngZone.run(()=>{this.loading=false;})
				let data={"MESSAGE":'Repeated/missing column labels'};
				this.throwError(data);
				return;
			}
			for(let col of this.excelCols){

				if(col.header!=(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader)){
					for(let project of this.excelJson){
						delete Object.assign(project, {[(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader)]: project[col.header] })[col.header];
						
						}
				}
			}
			$('#import').modal('hide');
			
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else{
				//this.getLibraries(parseInt(this.userId));
				this.getLibrariesSimple(parseInt(this.userId));
				this.totalLibraries = this.libraryData.length;
				Swal.fire({
					html: data.MESSAGE.replace('\\n', '<br>'), // do replace because we want to make newline chars \n to display in html
				})
				  }
				this.ngZone.run(()=>{
					this.loading=false;
				})
				
				

				
			})
			
		} else {
			this.ngZone.run(()=>{this.loading=true;})
			let inputJson={"PROCEDURE":"BatchUploadPCACostLibrary","USER_ID":parseInt(this.userId), "RW_PCA_COST_LIBRARIES":this.excelJson}
			console.log(inputJson);
			
			let array=[];
			for(let col of this.excelCols){
				array.push(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader);
				
			}
			if(!array.every(val => this.presetCostCols2.includes(val))|| this.hasDuplicates(array)){
				this.ngZone.run(()=>{this.loading=false;})
				let data={"MESSAGE":'Repeated/missing column labels '};
				this.throwError(data)
				return;
			}
			for(let col of this.excelCols){
				if(col.header!=(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader)){
					for(let project of this.excelJson){
						delete Object.assign(project, {[(col.changeHeader=='TITLE'? 'ITEM_TITLE':col.changeHeader)]: project[col.header] })[col.header];
						
						}
				}
			}
			$('#import').modal('hide');
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
				{
				
					if (data.RESPONSE_STATUS=='N') {
						this.throwError(data)
					  }else {
				console.log(data);
				this.getAllPCA();
				
				Swal.fire({
					html: data.MESSAGE.replace('\\n', '<br>'), // do replace because we want to make newline chars \n to display in html
				})
				this.totalPCA = this.allPCA.length;	
			}	
			this.ngZone.run(()=>{this.loading=false;})			
			})
			
		}
	
	}

	testFunction(){
		let content="<div style='font-size: 18; text-align: justify;'>"+
		"<label>Upload Library – First upload of Library spreadsheet ONLY</label><br>"+
		"<ul>"+
		"<li>You must select a header for each column before you upload.</li>"+
		"<li>Title field must be unique and cannot be blank.</li>"+
		"<li>If you upload a duplicate, you will receive an error message</li>"+
		"</ul>"+
		"<label>Upload Library - Revisions to master Library</label><br><ul><li>LIBRARY_ID must always be the FIRST column header when you upload a revised file.</li><li>Title field must be unique and cannot be blank.</li><li>If you upload a duplicate, you will receive an error message.</li>"+
		"<li>You must upload all the same columns you downloaded/exported from Scriva.</li></ul>"+
		"<label>Upload Cost Library – First upload of Library spreadsheet ONLY</label><br>"+
		"<ul>"+
		"<li>You must select a header for each column before you upload.</li>"+
		"<li>Title field must be unique and cannot be blank.</li>"+
		"<li>If you upload a duplicate, you will receive an error message</li>"+
		"</ul>"+
		"<label>Upload Cost Library - Revisions to master Library</label><br>"+
		"<ul>"+
		"<li>COST_LIBRARY_ID must always be the LAST column header when you upload a revised file.</li>"+
		"<li>Title field must be unique and cannot be blank.</li>"+
		"<li>If you upload a duplicate, you will receive an error message.</li>"+
		"<li>You must upload all the same columns you downloaded/exported from Scriva.</li>"+
		"</ul></div>"
		Swal.fire({
			showCloseButton : true,
			// title: "<p style='color: red'> How to use the Batch Project or Portfolio Upload: <p/>",
			html: content,  
			width: '800px'
		})	}

	changeCol(){

	}
	resetTypeList(){
		this.typeList=[];
	}
	
	allWatermarks=[];

	getAllWatermark(){
		let inputJson={"PROCEDURE":"getwatermarks", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else {
			this.allWatermarks=data.RW_WATERMARKS
			for(let i=0; i<this.allWatermarks.length;i++ ){
				this.allWatermarks[i] = {...this.allWatermarks[i], ...JSON.parse(this.allWatermarks[i].WM_DATA)};

			}
			console.log(this.allWatermarks);		
		}	
		});


	}
	typeList=[];
	getAllTempByTypeID( typeID) {
		let inputJson={"PROCEDURE":"getreportlistbytemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":typeID};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getAllTempByTypeID",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else {
			for (let obj of data.RW_REPORTS) {
				typeIdTemplates.push(obj);
			}
			this.typeList=typeIdTemplates;
		}
		});
		console.log(typeIdTemplates);
		
	}
	templateFilterOptions=[];
	templateFilterOptions2=[];
	getTemplateTypeCategory(){
		let inputJson={"PROCEDURE":"gettemplatetypecategory", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("templatetypecategory",data);
		//	this.templateFilterOptions.push(...data.RW_CATEGORY_LIST);
		if (data.RESPONSE_STATUS=='N') {
            this.throwError(data)
          }else {
		this.templateFilterOptions2=data.RW_CATEGORY_LIST;
			console.log("this.templateFilterOptions",this.templateFilterOptions)
		  }
		})

	}
	selectedFilter2
	filterTemplates(x){
		this.tt.filter(x.SUBCATEGORY_NAME, 'SUBCATEGORY_NAME', 'contains')
	}
	filterTemplates2(x){
		this.tt.filter(x.CATEGORY, 'CATEGORY_NAME', 'contains')
	}
	selectedFilter;
	allCoverPages=[];
	allCover=0
	getAllCoverpages(){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
			{ 
				console.log(data)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else {
				this.allCoverPages=data.RW_COVERPAGES
				this.allCover = this.allCoverPages.length;
				  }
		})
		

	}
	allHeaders=[];
	allFooters=[];
	allHead=0;
	getAllHeaders(){
		let inputJson={"PROCEDURE":"getallheaders", "USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
			{ 
				console.log(data)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else {
				this.allHeaders=data.RW_HEADERS
			this.allHead = this.allHeaders.length;
				  }		
			})
				

	}
	allFoot=0;
	getAllFooters(){
		let inputJson={"PROCEDURE":"getallfooters", "USER_ID":parseInt(this.userId)}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
			{ 
				console.log(data)
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else {
				this.allFooters=data.RW_FOOTERS
			this.allFoot = this.allFooters.length;
				  }		
			})
			
	}
	rgba2hex(orig) {
		var a, isPercent,
		  rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
		  alpha = (rgb && rgb[4] || "").trim(),
		  hex = rgb ?
		  (rgb[1] | 1 << 8).toString(16).slice(1) +
		  (rgb[2] | 1 << 8).toString(16).slice(1) +
		  (rgb[3] | 1 << 8).toString(16).slice(1) : orig;
	  
		if (alpha !== "") {
		  a = alpha;
		} else {
		  a = 1;
		}
		// multiply before convert to HEX
		a = ((a * 255) | 1 << 8).toString(16).slice(1)
		hex = a+ hex;
	  
	console.log(hex)
	  }
	watermarkTitle;
	watermarkData={

		text:"Draft",
		position:"",
		fontname:"Helvetica",
		fontsize:"10",
		color:"",
			pdf_url:""
		
	};
	resetWatermark(){
		this.watermarkTitle="";
		this.watermarkData={

			text:"Draft",
			position:"",
			fontname:"Helvetica",
			fontsize:"10",
			color:"",
			pdf_url:""
		};
	}
	addWatermarkPermission = false; // also used for deleting watermark
	checkAddWatermarkPermission() {
		this.addWatermarkPermission = false;
		
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 40};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.addWatermarkPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { $('#watermarkForm').modal('hide'); }, 250);
			} else {
				this.addWatermarkPermission = true;
			}
		}
		});
	}
	watermarkToEdit;
	watermarkEdit=false;
	watermarkWarn=false;
	addWatermark(){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 40};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				this.watermarkWarn=false;
				if(this.watermarkTitle.trim().length==0||this.watermarkData.text.trim().length==0||this.watermarkData.position.trim().length==0||this.watermarkData.fontname.trim().length==0||this.watermarkData.color.trim().length==0||this.watermarkData.fontsize.length==0){
					this.watermarkWarn=true;
					return
				}
				let inputJson={"PROCEDURE":"insertwatermark", "USER_ID":parseInt(this.userId), "WM_TITLE":this.watermarkTitle,  "WM_DATA":JSON.stringify(this.watermarkData)};
				$('#watermarkForm').modal('hide');
				this.resetWatermark();
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data =>{ 
					console.log(data)
					if (data.RESPONSE_STATUS == 'Y') {
						data = {...data, ...JSON.parse(data.WM_DATA)};
						this.allWatermarks=[data, ...this.allWatermarks]
					} else {
						this.throwError(data)
					}
				})
			}
		}
		});
		
	}
	deleteWatermark(){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 40};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				let inputJson={"PROCEDURE":"deletewatermark", "USER_ID":parseInt(this.userId), "WATERMARK_ID":this.watermarkToEdit.WATERMARK_ID}
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
					{ console.log(data)
						if(data.RESPONSE_STATUS=='Y'){
						let index=this.allWatermarks.findIndex(mark=>mark.WATERMARK_ID==this.watermarkToEdit.WATERMARK_ID);console.log(index)
						if(index>-1){
							this.allWatermarks.splice(index, 1);
						}
						this.allWatermarks=[].concat(this.allWatermarks)
						}else{
							this.throwError(data)
						}
					})
			}
		}
		});
		
	}
	fillWatermark(){
		this.watermarkData=JSON.parse(this.watermarkToEdit.WM_DATA);
		this.watermarkTitle=this.watermarkToEdit.WM_TITLE
	}

	editWatermarkPermission = false;
	checkEditWatermarkPermission() {
		this.editWatermarkPermission = false;
		
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 39};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse);
				return										
			}
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
				this.editWatermarkPermission = false;

				// close the modal. the timeout is to give it time to load. very hacky, find a better way
				setTimeout(() => { $('#watermarkForm').modal('hide'); }, 250);
			} else {
				this.editWatermarkPermission = true;
			}

		});
	}
	editWatermark(){
		// first check if user has permission:
		let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 39};
		console.log(checkUserInputJson);
		this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
			console.log(checkResponse)
			if (checkResponse.RESPONSE_STATUS=='N') {
				this.throwError(checkResponse)
			  }else {
			if (checkResponse.USER_PERMISSION == 'N') {
				this.throwError(checkResponse)
			} else {
				
				this.watermarkWarn=false;
				if(this.watermarkTitle.trim().length==0||this.watermarkData.text.trim().length==0||this.watermarkData.position.length==0||this.watermarkData.fontname.length==0||this.watermarkData.color.trim().length==0||this.watermarkData.fontsize.length==0){
					this.watermarkWarn=true;
					return
				}
				let inputJson={"PROCEDURE":"insertwatermark", "USER_ID":parseInt(this.userId), "WATERMARK_ID": this.watermarkToEdit.WATERMARK_ID, "WM_TITLE":this.watermarkTitle,  "WM_DATA":JSON.stringify(this.watermarkData)};
				$('#watermarkForm').modal('hide');
				this.resetWatermark();
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => 
					{ 
						if (data.RESPONSE_STATUS == 'Y') {
							console.log(data);
							data = {...data, ...JSON.parse(data.WM_DATA)};
							let index=this.allWatermarks.findIndex(mark=>mark.WATERMARK_ID==data.WATERMARK_ID);
							if(index>-1){
								this.allWatermarks[index]=data
							}
							this.allWatermarks=[].concat(this.allWatermarks)
							console.log(this.allWatermarks)
						} else {
							this.throwError(data);
						}
					})
			}
		}
		});
		
	}

	changeUserDetails(type, user){
	//	let inputJson = { "PROCEDURE": "insertwatermark", "USER_ID": parseInt(this.userId), "WATERMARK_ID": user.WATERMARK_ID,}
		let test=JSON.parse(user.WM_DATA);
		test[type]=user[type+"_TOEDIT"];
		user[type]=user[type+"_TOEDIT"];
		let inputJson = { "PROCEDURE": "insertwatermark", "USER_ID": parseInt(this.userId), "WATERMARK_ID": user.WATERMARK_ID, "WM_DATA":JSON.stringify(test)}
		console.log('changeUserDetails', inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }
			console.log(data);
		});
	}

	uploadtype;
	hfTitle;
	hfURL;
	public uploadHF(){
		let that=this;

		const file = this.hfFile.nativeElement.files[0];console.log(file)
		if(!file){			

			return
		}
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
    //this.fileReader.readAsDataURL(file);
		let reader = new FileReader();  
        reader.onloadend = function(e) {
			let data = e.target.result.toString().split(',')[1];; console.log(data)//upload service
			//let inputJson={"filename":file.name,"customerid":that.userId,"Order":'123',"reportID":'123','r':'123',"fdata":data}; console.log(inputJson)
			let inputJson={"filename":file.name,"order_num":"","reportID":"","r":that.r,"desc":"","fdata":data, "user_id":parseInt(that.userId), "FILE_TYPE":"FILE"}
			that.reportService.uploadFile2(inputJson).subscribe(result=>{
				console.log("result", result);
				if (result.RESPONSE_STATUS=='N') {
					that.throwError(result);
					return										
				}
				that.hfURL=result.FILE_URL
				//that.hfFile.nativeElement.value = null;
			})
			//.error
		}
		reader.readAsDataURL(file);
  
	}
	resetHF(){
		this.uploadtype="";
		this.hfTitle="";
		this.hfURL="";
	}

	insertHF(){
		if(!this.hfURL){
			let data={"MESSAGE":'Upload File First'};
			this.throwError(data);
		}
		let inputJson;
		if(this.uploadtype=="Coverpage"){
			inputJson= {"PROCEDURE":"insertcoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_TITLE":this.hfTitle, "COVERPAGE_URL":this.hfURL, "COVERPAGE_DATA":""}
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
				  }else{
				if(this.uploadtype=="Coverpage"){
					this.allCoverPages=[data,...this.allCoverPages]
				}
				this.resetHF();
				this.allCover = 0;
				for(var i in this.allCoverPages){
		  		this.allCover++
	  			}
				$('#uploadHF').modal('hide');
			}
			});
		}else{
			let that=this;

			const file = this.hfFile.nativeElement.files[0];console.log(file)
			if(!file){			
	
				return
			}
			const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		//this.fileReader.readAsDataURL(file);
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				let data = e.target.result.toString(); console.log("readerdata", data)//upload service
				let html=data
				html += that.reportService.tagEnd
				let allhtml=btoa(encodeURIComponent(html).replace(/%([0-9A-F]{2})/g, function (match, p1) {
					return String.fromCharCode(parseInt('0x' + p1, 16));
				}));
			console.log(allhtml);
			let inputJson={"user_id":parseInt(that.userId),"company_id":that.userInfo.COMPANY_ID.toString(),"hf_title":that.hfTitle,"hf_data":allhtml,"hf_content": JSON.stringify({"text":data,"height":80})
			,"type":that.uploadtype=="header"? "HEADER":"FOOTER"};
			console.log(JSON.stringify(inputJson));
			that.reportService.saveHeaderFooter(inputJson).subscribe(data => {
				if(that.uploadtype=="header"){
					that.allHeaders=[data,...that.allHeaders];
					that.allHead = 0;
					for(var i in that.allHeaders){
					that.allHead++
					}	
				}else{
					that.allFooters=[data,...that.allFooters];
					that.allFoot = 0;
					for(var i in that.allFooters){
		  			that.allFoot++
	  				}

				}
				console.log(data);
			})}
		

			
			reader.readAsText(file);
				
			
			



		}
	}
	addToIden(label, id){
		let ele='#'+id;
		let text=$(ele).val();console.log(text);
		if(text.length>0){
			text=text+'; '+label;
		}else{
			text=label;
		}
		$(ele).val(text);		
	}
	

	addLabel2(e){
		let text=$('#libLabel').val();; console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				if(this.inputLabels.length>0){
					this.inputLabels+=';'+ar.trim()+';';
				}else{
					this.inputLabels+=ar.trim()+';';
				}
			}
		}
		$('#libLabel').val('');
	}

	addLabelPCA2(){
		let text=$('#pcaLabel').val(); console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				if(this.costLibraryForm.IDENTIFIERS.length>0){
					this.costLibraryForm.IDENTIFIERS+=';'+ar.trim()+';';
				}else{
					this.costLibraryForm.IDENTIFIERS+=ar.trim()+';';
				}
				
			}
		}
		$('#pcaLabel').val('');
	}
	deleteFile(data){console.log(data);
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson:any;
				if(data.COVERPAGE_ID>-1){
					inputJson={"PROCEDURE":"deletecoverpage","USER_ID":parseInt(that.userId),"COVERPAGE_ID":data.COVERPAGE_ID};
				}else if(data.HEADERFOOTER_ID>-1){
					inputJson={"PROCEDURE":"deleteheaderfooter", "USER_ID":parseInt(that.userId), "HEADERFOOTER_ID":data.HEADERFOOTER_ID};
				}
				console.log(inputJson);
				that.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
					console.log(response)
					let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
					if(response.RESPONSE_STATUS=="Y"){
						if(data.COVERPAGE_ID>-1){
						let index=this.allCoverPages.findIndex(cover=>cover.COVERPAGE_ID==data.COVERPAGE_ID);
						if(index>-1){
							this.allCoverPages.splice(index, 1);
						}
						}else if(data.HEADERFOOTER_ID>-1){
							if(data.TYPE=="HEADER"){
								let index=this.allHeaders.findIndex(header=>header.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
								if(index>-1){
									this.allHeaders.splice(index, 1);
								}
							}else if(data.TYPE=="FOOTER"){
								let index=this.allFooters.findIndex(footer=>footer.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
								if(index>-1){
									this.allFooters.splice(index, 1);
								}
							}
						}
						Toast.fire({
							icon: 'success',
							title: response.MESSAGE
						})
					
					}else{
						this.throwError(response);
					}

					
				});
			}	
		})	
		
		
		
		
	}
	trackByFuntion(index, item) {
		return index;
	}
	async getSftContent(data){
		await this.getLibContent(data);
		if(data.CONTENT_HTML&&data.CONTENT_HTML.length>0){
			data.htmltext=this.sanitizer.bypassSecurityTrustHtml(data.CONTENT_HTML);
			
		}
		
	}
	public upload() {
		
			this.file3.nativeElement.click();
		
	}
	uploading=false;
	uploadFile1(){
		this.uploading=true;
		let that=this;
		const files = this.file3.nativeElement.files; console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for (let file of files)  //for multiple files
		{
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
	}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();  
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":"","project_id":"","file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{console.log(result);
					console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						throwError(result);
						that.uploading=false;
						console.log(result.ERRORCODE)
					}else{
						that.newSlotFile.name=result.FILE_NAME;
						that.newSlotFile.url=result.FILE_URL;
						that.newSlotFile.ext=result.FILE_EXTENSION;
						console.log(that.newSlotFile)
						that.uploading=false;
					}					
				})			
		}
		reader.readAsDataURL(file);
		} 
		
  }
  sideNavWidth = '66px'
  toggleSideBarVar = false
  toggleSideBar(){
	  if(this.toggleSideBarVar == false) {
		  this.sideNavWidth = '400px'
		  this.toggleSideBarVar = true
	  } else if(this.toggleSideBarVar == true) {
		  this.sideNavWidth = '66px'
		  this.toggleSideBarVar = false

	  }

  }
  setDefaultWM(id){

	// first check if user has permission:
	let checkUserInputJson={"PROCEDURE":"checkuserpermission", "USER_ID":parseInt(this.userId), "FUNCTION_ID": 40};
	console.log(checkUserInputJson);
	this.reportService.univeralService(JSON.stringify(checkUserInputJson)).subscribe(checkResponse => {
		console.log(checkResponse)
		if (checkResponse.RESPONSE_STATUS=='N') {
			this.throwError(checkResponse)
		  }else{
		if (checkResponse.USER_PERMISSION == 'N') {
			this.throwError(checkResponse);
			this.getAllWatermark(); //reload the checkbox
		} else {
			let inputJson={"PROCEDURE":"updaterwprofile","USER_ID":parseInt(this.userId),'COMPANY_ID':this.userInfo.COMPANY_ID.toString(), "DEFAULT_WATERMARK_ID":id};
			console.log(inputJson);		
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
				console.log(response);
				if(response.RESPONSE_STATUS=='Y'){
					this.getAllWatermark();
					let Toast=Swal.mixin({
						toast: true,						
							position: 'center',
							showConfirmButton: false,
							timer: 3000
						})
					Toast.fire({
						icon: 'success',
						title: response.MESSAGE,
					})
				}else{

					this.throwError(response);
				}
			})	
		}
	}
	});
	  
  }
  private throwError(data){
	if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
		console.log('Timeout');
		Swal.fire({
			html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
		})
		this.cookieService.clearAll();
		this.router.navigate(['/']);			
	}else{
		Swal.fire({
			html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
		})
	}
  }
  
}